export default __webpack_public_path__ + "static/media/2181.ec44a4ec.png";